import React from 'react';
import ReactDOM from 'react-dom/client';
import {Dishes} from "./dishes.js"
import { Test } from './test.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <Dishes/>
  </>
);
